require('./dist/select.js');
module.exports = 'ui.select';



//////////////////
// WEBPACK FOOTER
// ./bower_components/angular-ui-select/index.js
// module id = 732
// module chunks = 0